import api from './api';

export const FUND_TYPES = {
  GENERAL: 'GENERAL',
  CASH_ADVANCE: 'CASH_ADVANCE',
  TRAVEL: 'TRAVEL',
};

export const FUND_CATEGORIES = [
  'OPERATIONAL',
  'PEMBELIAN MATERIAL',
  'SHE/MCU',
  'EKSPEDISI MATERIAL',
  'KASBON/UPAH KERJA',
  'TIKET/MOBILISASI',
  'PEMBELIAN PERALATAN',
  'LAINNYA',
];

export const INDONESIAN_BANKS = [
  'BANK CENTRAL ASIA (BCA)',
  'BANK MANDIRI',
  'BANK RAKYAT INDONESIA (BRI)',
  'BANK NEGARA INDONESIA (BNI)',
  'BANK TABUNGAN NEGARA (BTN)',
  'BANK DANAMON',
  'BANK CIMB NIAGA',
  'BANK MAYBANK',
  'BANK PANIN',
  'BANK UOB',
  'BANK OCBC NISP',
  'BANK SYARIAH INDONESIA (BSI)',
  'BANK MUAMALAT',
  'BANK MEGA',
  'BANK PERMATA',
  'BANK JAGO',
  'BANK DIGITAL',
  'BANK ALFAMART',
  'BANK BTPN',
  'BANK BCA SYARIAH',
  'BANK BNI SYARIAH',
  'BANK BRI SYARIAH',
  'BANK MANDIRI SYARIAH',
  'BANK MAYBANK SYARIAH',
  'BANK CIMB NIAGA SYARIAH',
  'BANK MUAMALAT SYARIAH',
  'BANK SINARMAS',
  'BANK MESTIKA DHARMA',
  'BANK MAYAPADA',
  'BANK BUKOPIN',
  'BANK BJB',
  'BANK DKI',
  'BANK BPD BALI',
  'BANK BPD JATENG',
  'BANK BPD JATIM',
  'BANK BPD KALTIM',
  'BANK BPD KALSEL',
  'BANK BPD SULSEL',
  'BANK BPD SULTRA',
  'BANK BPD SULTENG',
  'BANK BPD MALUKU',
  'BANK BPD PAPUA',
  'BANK NTT',
  'BANK BPD LAMPUNG',
  'BANK BPD BENGKULU',
  'BANK BPD ACEH',
  'BANK BPD SUMBAR',
  'BANK BPD RIAU',
  'BANK BPD SUMSEL',
  'BANK BPD JAMBI',
  'BANK BPD BANTEN',
  'BANK BPD KALTENG',
  'BANK BPD SULBAR',
  'BANK BPD GORONTALO',
  'BANK BPD MALUKU UTARA',
  'BANK BPD PAPUA BARAT',
  'BANK BPD SULAWESI TENGAH',
  'BANK BPD SULAWESI SELATAN',
  'BANK BPD SULAWESI TENGGARA',
  'BANK BPD SULAWESI UTARA',
  'BANK BPD NUSA TENGGARA BARAT',
  'BANK BPD NUSA TENGGARA TIMUR',
  'BANK BPD KALIMANTAN TENGAH',
  'BANK BPD KALIMANTAN SELATAN',
  'BANK BPD KALIMANTAN TIMUR',
  'BANK BPD KALIMANTAN UTARA',
  'BANK BPD SUMATERA UTARA',
  'BANK BPD SUMATERA BARAT',
  'BANK BPD RIAU KEPULAUAN',
  'BANK BPD KEPULAUAN BANGKA BELITUNG',
  'BANK BPD LAMPUNG',
  'BANK BPD BENGKULU',
  'BANK BPD JAWA TENGAH',
  'BANK BPD JAWA TIMUR',
  'BANK BPD JAWA BARAT',
  'BANK BPD DI YOGYAKARTA',
  'BANK DKI',
  'BANK BPD BALI',
  'BANK BPD NUSA TENGGARA BARAT',
  'BANK BPD NUSA TENGGARA TIMUR',
  'BANK BPD KALIMANTAN SELATAN',
  'BANK BPD KALIMANTAN TIMUR',
  'BANK BPD KALIMANTAN TENGAH',
  'BANK BPD SULAWESI SELATAN',
  'BANK BPD SULAWESI TENGAH',
  'BANK BPD SULAWESI UTARA',
  'BANK BPD SULAWESI BARAT',
  'BANK BPD MALUKU',
  'BANK BPD MALUKU UTARA',
  'BANK BPD PAPUA',
  'BANK BPD PAPUA BARAT',
  'BANK BPD GORONTALO',
];

export const KASBON_CATEGORIES = ['UPAH KERJA', 'KASBON PRIBADI', 'KASBON ALAT KERJA'];

export const TRAVEL_PURPOSES = [
  'PERJALANAN KE SITE',
  'SURVEY',
  'KUNJUNGAN',
  'CUTI',
  'MEETING',
  'OPERASIONAL PROYEK',
  'LAINNYA'
];

export const listFundRequests = (params = {}) =>
  api.get('/fund-requests', { params }).then(res => res.data);

export const getFundRequest = id =>
  api.get(`/fund-requests/${id}`).then(res => res.data?.data || res.data);

export const createFundRequest = payload =>
  api.post('/fund-requests', payload).then(res => res.data?.data || res.data);

export const updateFundRequest = (id, payload) =>
  api.put(`/fund-requests/${id}`, payload).then(res => res.data?.data || res.data);

export const submitFundRequest = id =>
  api.post(`/fund-requests/${id}/submit`).then(res => res.data?.data || res.data);

export const approveFundRequest = (id, { stepId, note }) =>
  api.post(`/fund-requests/${id}/approve`, { stepId, note }).then(res => res.data?.data || res.data);

export const rejectFundRequest = (id, { stepId, note }) =>
  api.post(`/fund-requests/${id}/reject`, { stepId, note }).then(res => res.data?.data || res.data);

export const releaseFundRequest = (id, { referenceNo, attachmentUrl, amount, description }) =>
  api.post(`/fund-requests/${id}/release`, { referenceNo, attachmentUrl, amount, description }).then(res => res.data?.data || res.data);

export const remindFundRequest = (id) =>
  api.post(`/fund-requests/${id}/remind`).then(res => res.data?.data || res.data);

export const listPayees = (search = '') =>
  api.get('/fund-requests/payees', { params: { q: search || undefined } })
    .then(res => res.data?.data || res.data || [])
    .catch(() => []);

export const upsertPayee = payload =>
  api.post('/fund-requests/payees', payload).then(res => res.data?.data || res.data);

// ── Rekening (Payee) management — accounting & finance_manager (payee:manage) ──
export const listPayeesManage = ({ q = '', page = 1, pageSize = 25 } = {}) =>
  api.get('/fund-requests/payees/manage', { params: { q: q || undefined, page, pageSize } })
    .then(res => res.data);

export const createPayee = payload =>
  api.post('/fund-requests/payees/manage', payload).then(res => res.data?.data || res.data);

export const updatePayee = (id, payload) =>
  api.put(`/fund-requests/payees/${id}`, payload).then(res => res.data?.data || res.data);

export const deletePayee = id =>
  api.delete(`/fund-requests/payees/${id}`).then(res => res.data);

export const uploadFundAttachment = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post('/upload/file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  // backend returns { file: { url, filename, mimetype, size, ... } }
  return res.data?.file || res.data;
};

export const listMandors = (search = '', projectId) =>
  api.get('/fund-requests/mandors', { params: { q: search || undefined, projectId: projectId || undefined } })
    .then(res => res.data?.data || res.data || [])
    .catch(() => []);

export const listInstallationTeams = (search = '') =>
  api.get('/installation-teams', { params: { q: search || undefined, isActive: true } })
    .then(res => {
      const data = res.data;
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.installationTeams)) return data.installationTeams;
      if (Array.isArray(data?.data)) return data.data;
      return [];
    })
    .catch(() => []);
export const upsertMandor = payload =>
  api.post('/fund-requests/mandors', payload).then(res => res.data?.data || res.data);

export const listTravelCities = (search = '') =>
  api.get('/fund-requests/travel-cities', { params: { q: search || undefined } })
    .then(res => res.data?.data || res.data || [])
    .catch(() => []);

export const deleteFundRequest = (id) =>
  api.delete(`/fund-requests/${id}`).then(res => res.data?.data || res.data);

export const getFundRequestSummary = (params = {}) =>
  api.get('/fund-requests/summary', { params }).then(res => res.data?.data || res.data);

export const exportFundRequestExcel = async (id) => {
  const res = await api.get(`/fund-requests/${id}/export`, { responseType: 'blob' });
  return res.data;
};

export const exportTransferSummary = async (date) => {
  const res = await api.get('/fund-requests/summary/export', { params: { date }, responseType: 'blob' });
  return res.data;
};
